import { render, staticRenderFns } from "./DashboardTV.vue?vue&type=template&id=adadf404&scoped=true"
import script from "./DashboardTV.vue?vue&type=script&lang=js"
export * from "./DashboardTV.vue?vue&type=script&lang=js"
import style0 from "./DashboardTV.vue?vue&type=style&index=0&id=adadf404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adadf404",
  null
  
)

export default component.exports